import React, { useState, useCallback } from 'react';
import Modal from '@material-ui/core/Modal';
import {
  makeStyles,
  createStyles,
  createTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import LocalGasStation from '@material-ui/icons/LocalGasStation';
import {
  DataGrid,
  GridColDef,
  ptBR,
  GridCellParams,
  GridValueFormatterParams,
  isDateValid,
  GridComparatorFn,
} from '@material-ui/data-grid';
import ButtonGridDatails from '../ButtonGridDatails';
import api from '../../services/api';
import Close from '@material-ui/icons/Close';
import TextFieldGrid from '../TextFieldGrid';
import { format, addHours } from 'date-fns';

import './index.scss';
import { formatFieldStatus, formatFieldTipo } from '../../utils/formatValues';

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);
const theme = createTheme({}, ptBR);

const dateTimeComparator: GridComparatorFn = (v1, v2) => {
  if (new Date(v1 as string) > new Date(v2 as string)) return 1;
  if (new Date(v1 as string) < new Date(v2 as string)) return -1;
  return 0;
};
const columns: GridColDef[] = [
  {
    field: 'dataHoraEnvio',
    headerName: 'Data/Hora',
    width: 160,
    type: 'dateTime',
    sortComparator: dateTimeComparator,
    valueFormatter: (params: GridValueFormatterParams) => {
      if (params.value && isDateValid(new Date(params.value.toString()))) {
        return format(
          addHours(new Date(params.value?.toString()), - 3),
          'dd/MM/yyyy HH:mm:ss',
        );
      }
      return '';
    },
    renderCell: (params: GridCellParams) => (
      <TextFieldGrid
        status={params.getValue(params.id, 'status')?.toString()}
        value={params.formattedValue?.toString()}
      />
    ),
  },
  {
    field: 'tipo',
    headerName: 'Tipo',
    headerAlign: 'center',
    align: 'center',
    width: 105,
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatFieldTipo(params.value);
    },
    renderCell: (params: GridCellParams) => (
      <TextFieldGrid
        status={params.getValue(params.id, 'status')?.toString()}
        value={params.formattedValue?.toString()}
      />
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatFieldStatus(params.value);
    },
    renderCell: (params: GridCellParams) => (
      <TextFieldGrid
        status={params.getValue(params.id, 'status')?.toString()}
        value={params.formattedValue?.toString()}
      />
    ),
  },
  {
    field: 'messageErrorIpp',
    headerName: 'Detalhes',
    width: 320,
    flex: 1,
  },
  {
    field: '',
    headerName: '',
    sortable: false,
    width: 30,
    renderCell: (params: GridCellParams) => {
      if (params.getValue(params.id, 'status')?.toString() === 'R')
        return (
          <ButtonGridDatails
            messageErrorIpp={params
              .getValue(params.id, 'messageErrorIpp')
              ?.toString()}
          />
        );

      return <></>;
    },
  },
];

interface ParamDetail {
  pv: number | undefined;
  nomePv: string | undefined;
  cnpjPv: string | undefined;
  open: boolean;
  handleClose(): void;
}

interface DataDetailsPv {
  id: string;
  dataHoraEnvio: string;
  status: string;
  messageErrorIpp: string;
}

const GridModalDetails: React.FC<ParamDetail> = ({
  pv,
  cnpjPv,
  nomePv,
  open,
  handleClose,
}) => {
  const classes = useStyles();
  const [dataPvs, setDataPvs] = useState<DataDetailsPv[]>([]);
  const [loading, setLoading] = useState(false);

  const handleGetCominicationData = useCallback(() => {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_URL_GET_PONTOS_VENDA}Detalhes/${pv}`, {
        headers: {
          'Access-Control-Allow-Origin': true,
        },
      })
      .then((resp) => {
        setDataPvs(resp.data.detalhesPontoVenda);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  return (
    <Modal
      aria-labelledby="details-modal-label"
      aria-describedby="details-modal-describe"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      onRendered={handleGetCominicationData}
    >
      <div className="container-modal">
        <div className="container-pv-name">
          <LocalGasStation color="action" style={{ fontSize: 50 }} />
          <span>{nomePv}</span>
          <button type="button" className="btn-close" onClick={handleClose}>
            <Close color="action" style={{ fontSize: 18 }} />
          </button>
        </div>
        <div className="container-pv-data">
          <div>
            <strong>Código:</strong>
            <span>{pv}</span>
          </div>
          <div className="container-cnpj">
            <strong>CNPJ:</strong>
            <span>{cnpjPv}</span>
          </div>
        </div>
        <ThemeProvider theme={theme}>
          <DataGrid
            className="grid-data"
            rows={dataPvs}
            columns={columns}
            rowsPerPageOptions={[10]}
            pageSize={10}
            headerHeight={30}
            rowHeight={25}
            disableColumnSelector={true}
            disableColumnFilter={true}
            disableColumnMenu={true}
            disableSelectionOnClick={true}
            loading={loading}
          />
        </ThemeProvider>
      </div>
    </Modal>
  );
};

export default GridModalDetails;
